export default "__VITE_ASSET__UooqrTvQ__"